import {Router} from '@angular/router';
import {environment} from '@env';

const ROUTE_SUFFIX_MAP: Record<string, string> = {
    ITEM: 'item-detail',
    ITEM_GROUPING: 'item-group-detail',
    MODIFIER_GROUPING: 'modifier-group-detail',
    MODIFIER: 'modifier-detail',
};

export function openCommonItemInReact(
    router: Router,
    itemClass: string,
    itemTag: string,
    queryParams?: Record<string, string>,
): void {
    const routeSuffix = ROUTE_SUFFIX_MAP[itemClass];
    if (!routeSuffix) {
        return;
    }

    if (environment.reactUrl != null) {
        const search = queryParams ? '?' + new URLSearchParams(queryParams).toString() : '';
        window.open(`${environment.reactUrl}/menu-builder/${routeSuffix}/${itemTag}${search}`, '_blank');
    } else {
        const url = router.serializeUrl(
            router.createUrlTree([`/common-items/${routeSuffix}`, itemTag], {queryParams})
        );
        window.open(url, '_blank');
    }
}
